export default {
  slug: "tariff",
  title: "Tariff of charges",
  tier: "UK lending",
  group: "uk",
  appliesTo: "Daksfirst Limited; UK bridging and buy-to-let loans",
  lead: "Every type of fee or charge that may apply to a Daksfirst loan in addition to interest. The amount of each is confirmed in your Decision in Principle and fixed in your facility letter.",
  sections: [
    { id: "about", h: "How this tariff works", body: [
      "This page lists every type of fee or charge that may apply to a Daksfirst bridging or buy-to-let loan in addition to interest. The amount of each is confirmed in your Decision in Principle and fixed in your facility letter, which takes precedence over this page. We will not charge a fee of a type that does not appear here, and we will not charge an amount that is not in your facility letter.",
      "Where a fee is stated as 'at cost' we pass on the third party's charge without mark-up and tell you the amount before it is incurred. All fees are exclusive of VAT unless stated."
    ]},
    { id: "before", h: "Before completion", body: [
      { table: { head: ["Fee", "What it covers"], rows: [
        ["Valuation fee", "Payable to the valuer on instruction, at cost. Non-refundable if the loan does not proceed."],
        ["Legal fees", "Our solicitors' fees, at cost, payable on completion or on withdrawal for work done. An estimate is given before instruction."],
        ["Administration fee", "Underwriting, searches and credit reports. Stated in the DIP. Non-refundable."],
        ["Commitment fee", "Where applicable, payable on acceptance of the term sheet and deducted from the arrangement fee on completion."]
      ]}}
    ]},
    { id: "completion", h: "On completion", body: [
      { table: { head: ["Fee", "What it covers"], rows: [
        ["Arrangement fee", "Stated in the facility letter, typically deducted from the advance."],
        ["Broker fee", "Where we pay your broker from the proceeds on your instruction; the amount is disclosed in the facility letter."],
        ["Funds transfer", "Per CHAPS or telegraphic transfer."],
        ["Deed of priority or postponement", "Where another lender's charge must be postponed."]
      ]}}
    ]},
    { id: "term", h: "During the term", body: [
      { table: { head: ["Fee", "What it covers"], rows: [
        ["Extension fee", "On any agreed extension of the repayment date."],
        ["Variation or consent fee", "For consent to a letting, works, a change of guarantor or any other variation you request."],
        ["Further advance fee", "Stated in the supplemental facility letter."],
        ["Re-inspection", "Where a valuer must revisit, at cost."],
        ["Duplicate documents and additional redemption statements", "Per request beyond those provided as standard."]
      ]}}
    ]},
    { id: "default", h: "Arrears and default", body: [
      { table: { head: ["Fee", "What it covers"], rows: [
        ["Default interest", "The rate in your facility letter, applied to the amount in default from the date of an unremedied breach or from the repayment date if the loan is neither repaid nor extended."],
        ["Missed or returned payment", "Per payment not received on the due date or returned unpaid."],
        ["Arrears management", "Where the account is in arrears, to cover monitoring and correspondence."],
        ["Field agent visit", "Where we instruct a visit to the property after other contact has failed, at cost."],
        ["Enforcement costs", "Receiver, solicitor and other costs of enforcing our security, at cost, recovered under the facility letter."]
      ]}}
    ]},
    { id: "repayment", h: "Repayment", body: [
      { table: { head: ["Fee", "What it covers"], rows: [
        ["Exit fee", "Where your facility letter provides for one."],
        ["Minimum interest period", "If you repay before the end of the minimum period, interest to the end of that period is payable."],
        ["Security release", "Discharge of the charge and Land Registry filings, per security."]
      ]}},
      "The fee types on this page are reviewed at least annually. The facility letter in force for your loan applies regardless of later changes to this page."
    ]}
  ],
  version: "1.0",
  status: "Effective 22 September 2026",
  owner: "Head of Operations"
};
